'use client';
import React, { useState } from 'react';
import { ShoppingCart } from 'lucide-react';
import { useRouter } from 'next/navigation';
import { useOrderStore } from '@/store/orderStore';
import Toast from '@/components/ui/Toast';

interface BuyNowButtonProps {
  course: {
    id: number;
    name: string;
    image: string;
    price: number;
  };
  className?: string;
}

const BuyNowButton: React.FC<BuyNowButtonProps> = ({ course, className = '' }) => {
  const router = useRouter();
  const { createOrderFromCourse } = useOrderStore();
  const [toast, setToast] = useState<{
    message: string;
    type: 'success' | 'error' | 'info';
  } | null>(null);

  const handleBuyNow = () => {
    try {
      // Tạo đơn hàng từ khóa học
      createOrderFromCourse(course);

      // Hiển thị thông báo thành công
      setToast({
        message: `Đã tạo đơn hàng cho "${course.name}" - Chuyển đến trang đơn hàng...`,
        type: 'success',
      });

      // Chuyển đến trang đơn hàng sau 0.5 giây
      setTimeout(() => {
        router.push('/don-hang');
      }, 500);
    } catch (error) {
      setToast({
        message: 'Có lỗi xảy ra khi tạo đơn hàng',
        type: 'error',
      });
    }
  };

  return (
    <>
      {toast && <Toast data-component-id="src/components/common/BuyNowButton.tsx:51:16" data-component-path="src/components/common/BuyNowButton.tsx" data-component-line="51" data-component-end-line="51" data-component-file="BuyNowButton.tsx" data-component-name="Toast" data-component-content="%7B%22elementName%22%3A%22Toast%22%7D" message={toast.message} type={toast.type} onClose={() => setToast(null)} />}

      <button data-component-id="src/components/common/BuyNowButton.tsx:53:6" data-component-path="src/components/common/BuyNowButton.tsx" data-component-line="53" data-component-end-line="62" data-component-file="BuyNowButton.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22w-full%20bg-gradient-to-r%20from-%5B%23f55500%5D%20to-%5B%23e04e00%5D%20hover%3Afrom-%5B%23e04e00%5D%20hover%3Ato-%5B%23cc4700%5D%20font-bold%20%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20text-lg%20border-none%20p-2%20text-white%20h-14%20transition-all%20duration-300%20relative%20group%20overflow-hidden%20rounded-xl%20%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20shadow-lg%22%7D"
        className="w-full bg-gradient-to-r from-[#f55500] to-[#e04e00] hover:from-[#e04e00] hover:to-[#cc4700] font-bold 
                    text-lg border-none p-2 text-white h-14 transition-all duration-300 relative group overflow-hidden rounded-xl 
                    shadow-lg"
        tabIndex={0}
        style={{ transform: 'none' }}
        onClick={handleBuyNow}
      >
        <span data-component-id="src/components/common/BuyNowButton.tsx:61:8" data-component-path="src/components/common/BuyNowButton.tsx" data-component-line="61" data-component-end-line="61" data-component-file="BuyNowButton.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22group-hover%3Amr-8%20transition-all%20duration-300%22%2C%22textContent%22%3A%22MUA%20NGAY%20%F0%9F%9B%92%22%7D" className="group-hover:mr-8 transition-all duration-300">MUA NGAY 🛒</span>
      </button>
    </>
  );
};

export default BuyNowButton;
